import React from "react";
import PageHeader from "../../components/PageHeader";
import CategoryCreateComponent from "../../components/Category/CategoryCreate";

class CategoryCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Category Create"
                            Breadcrumb={[
                                { name: "Categories", navigate: "/categories" },
                                { name: "Category Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CategoryCreateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CategoryCreate;
